import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { WaitlistResponse } from 'app/reception/waitlist/services/waitlist-response';

@Injectable({ providedIn: 'root' })
export class WaitlistResponseService {
  protected baseUrl = `${environment.receptionApi}/waitlist-responses`;

  constructor(private http: HttpClient) {}

  public save(waitlistResponse: WaitlistResponse): Observable<WaitlistResponse> {
    return this.http.post(this.baseUrl, waitlistResponse).pipe(map((resp) => resp as WaitlistResponse));
  }

  public search(waitlistId: number): Observable<WaitlistResponse[]> {
    return this.http.get(`${this.baseUrl}?waitlistId=${waitlistId}`).pipe(map((resp) => resp as WaitlistResponse[]));
  }

  public load(responseId: number): Observable<WaitlistResponse> {
    return this.http.get(`${this.baseUrl}/${responseId}`).pipe(map((resp) => resp as WaitlistResponse));
  }
}
